<script setup>
import { computed } from 'vue';
import {
  COMPONENT_TYPES,
  findComponentByType,
} from 'dashboard/helper/templateHelper';
import {
  categoryLabel,
  isSystemTemplate,
  templateSegments,
  templateTitle,
  variableMeta,
} from 'dashboard/helper/segurocorTemplates';
import SystemTemplateBadge from './SystemTemplateBadge.vue';

const props = defineProps({
  template: { type: Object, required: true },
});

const title = computed(() => templateTitle(props.template));
const isSystem = computed(() => isSystemTemplate(props.template));
const category = computed(() => categoryLabel(props.template.category));
// Corpo com cada variável trocada pelo rótulo dela ("Nome do cliente"), não pelo {{nome}} cru.
const segments = computed(() =>
  templateSegments(
    findComponentByType(props.template, COMPONENT_TYPES.BODY)?.text || ''
  )
);
</script>

<template>
  <div class="flex flex-col gap-1 min-w-0">
    <div class="flex flex-wrap items-center gap-x-2 gap-y-1 min-w-0">
      <span class="text-sm font-medium text-n-slate-12">
        {{ title }}
      </span>
      <SystemTemplateBadge v-if="isSystem" />
      <span
        v-if="category"
        class="px-1.5 py-0.5 text-[0.6875rem] leading-none rounded-md bg-n-slate-3 text-n-slate-11 shrink-0"
      >
        {{ category }}
      </span>
    </div>
    <p class="mb-0 text-xs leading-5 text-n-slate-11 line-clamp-2">
      <template v-for="(segment, i) in segments" :key="i">
        <span v-if="segment.type === 'text'">{{ segment.text }}</span>
        <span v-else class="px-1 rounded bg-n-slate-3 text-n-slate-12">{{
          variableMeta(segment.key).label
        }}</span>
      </template>
    </p>
  </div>
</template>
